export default __webpack_public_path__ + "static/media/45a16b5e909130ccedda7b30cce52414.svg";